import {connect} from 'react-redux';
import VirtualEntry from './VirtualEntry.jsx';
import {
  setBowlerForVirtualEntry,
  setTeamForVirtualEntry
} from './actionTypes';
import {
  handleVirtualEntrySelectChecked,
  handleVirtualEntryCancelClick,
  handleVirtualEntryReactivateClick,
  handleVirtualEntryRefundClick
} from './actions';

const mapStateToProps = (state, props) => props;

const mapDispatchToProps = dispatch => ({
  onBowlerChange: (virtualEntryId, bowlerId) =>
    dispatch(setBowlerForVirtualEntry(virtualEntryId, bowlerId)),
  onTeamChange: (virtualEntryId, entryId) =>
    dispatch(setTeamForVirtualEntry(virtualEntryId, entryId)),
  onSelectChecked: (virtualEntryId) => dispatch(handleVirtualEntrySelectChecked(virtualEntryId)),
  onCancelClick: (virtualEntryId) => dispatch(handleVirtualEntryCancelClick(virtualEntryId)),
  onReactivateClick: (virtualEntryId) => dispatch(handleVirtualEntryReactivateClick(virtualEntryId)),
  onRefundClick: (virtualEntryId) => dispatch(handleVirtualEntryRefundClick(virtualEntryId))
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualEntry);



// WEBPACK FOOTER //
// ./src/features/admin/virtualEventDetail/VirtualEntryContainer.jsx